import classNames from 'classnames/bind';
import useUserAgent from 'hooks/useUserAgent';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

export default function UnsupportedBrowser() {
  const agent = useUserAgent();
  const isIe = agent.browser.name === 'ie';
  if (!isIe) return null;
  return (
    <div className={cx('UnsupportedBrowser')}>
      <div className={cx('inner')}>
        <strong className={cx('text')}>
          이 브라우저에서는 원활한 서비스 제공이 어렵습니다.&nbsp;
          <b>
            네이버 항공권의 원활한 이용을 위해 다른 브라우저를 이용해주세요.
          </b>
        </strong>
        <a
          className={cx('chrome')}
          title="크롬 다운로드"
          href="https://www.google.com/intl/ko/chrome/"
          target="_blank"
        />
        <a
          className={cx('whale')}
          title="웨일 다운로드"
          href="https://whale.naver.com/"
          target="_blank"
        />
      </div>
    </div>
  );
}
